import { faClockThreeThirtySolid, FaIcon } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'
import CheckboxWithLabelField from '../../contract/inputs/CheckboxWithLabelField'
import { useCertificateStore } from '@/modules/drivers/stores/certificateStore'

const CertificateOptions = () => {
  const { t } = useLocalize()
  const { data, setData } = useCertificateStore()
  return (
   <div className="tw-flex tw-gap-4">
      <div className="tw-max-w-[200px] tw-w-full tw-space-y-2">
        <div className="tw-jusit tw-flex tw-flex-1 tw-items-center tw-gap-2 tw-font-medium tw-text-content-base">
          <FaIcon icon={faClockThreeThirtySolid} className="tw-max-w-[12px]" />
          <p className="tw-text-sm tw-font-semibold tw-text-content-base">
            Opcje
          </p>
        </div>
      </div>
      <div className="tw-flex tw-flex-col tw-gap-1.5  tw-w-full" >
        <CheckboxWithLabelField
          field="englishVersion"
          data={data}
          setData={setData}
          label={'Pokaż tłumaczenia (ENG, FR)'}
        />
        {/* <CheckboxWithLabelField
          field="skipAllowanceForMinimalAmount"
          data={data}
          setData={setData}
          label={'Pokaż podgląd wydruku'}
        /> */}
      </div>
    </div>
  )
}

export default CertificateOptions
